/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";

import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
/* import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/esm/Dropdown"; */

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

import { loginRequest, b2cPolicies } from "./authConfig";

const NavigationBar = () => {

    /**
     * useMsal is hook that returns the PublicClientApplication instance, 
     * an array of all accounts currently signed in and an inProgress value 
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();

    return (
        <>
            <AuthenticatedTemplate>
                <div className="ml-auto">
                    {/* <Button variant="info" onClick={() => instance.loginRedirect(b2cPolicies.authorities.editProfile)} className="ml-auto">Edit Profile</Button> */}
                    <Button variant="secondary" onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })} className="ml-auto">Sign Out</Button>
                    {/* <DropdownButton variant="warning" className="ml-auto" drop="left" title="Sign Out">
                        <Dropdown.Item as="button" onClick={() => instance.logoutPopup({ postLogoutRedirectUri: "/", mainWindowRedirectUri: "/" })}>Sign out using Popup</Dropdown.Item>
                        <Dropdown.Item as="button" onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}>Sign out using Redirect</Dropdown.Item>
                    </DropdownButton> */}
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Button variant="secondary" onClick={() => instance.loginRedirect({...loginRequest, nonce: 'hTPpgF7XAKbW37rEUS6pEVZqmoI', extraQueryParameters: {sub_channel: 'ofa'}})} className="ml-auto">Sign In</Button>
                {/* <DropdownButton variant="secondary" className="ml-auto" drop="left" title="Sign In">
                    <Dropdown.Item as="button" onClick={() => instance.loginPopup(loginRequest)}>Sign in using Popup</Dropdown.Item>
                    <Dropdown.Item as="button" onClick={() => instance.loginRedirect(loginRequest)}>Sign in using Redirect</Dropdown.Item>
                </DropdownButton> */}
            </UnauthenticatedTemplate>
        </>
    );
};

export const PageLayout = (props) => {
    return (
        <>
            <Navbar bg="primary" variant="dark">
                <a className="navbar-brand" href="/">ONEPassport Demo App</a>
                <NavigationBar />
            </Navbar>
            <br />
            <h5><center>Welcome to the ONEPassport Demo App</center></h5>
            <br />
            {props.children}
            <br />
            {/* <AuthenticatedTemplate>
                <footer>
                    <center>How did we do?
                        <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbR73pcsbpbxNJuZCMKN0lURpUMlRHSkc5U1NLUkxFNEtVN0dEOTFNQkdTWiQlQCN0PWcu" target="_blank"> Share your experience!</a>
                    </center>
                </footer>
            </AuthenticatedTemplate> */}
        </>
    );
};

export const IdTokenClaims = (props) => {
    return (
        <div id="token-div">
            <p><strong>AUD: </strong> {props.idTokenClaims.aud}</p>
            <p><strong>ISS: </strong> {props.idTokenClaims.iss}</p>
            <p><strong>SUB: </strong> {props.idTokenClaims.sub}</p>
            <p><strong>NONCE: </strong> {props.idTokenClaims.nonce}</p>
        </div>
    );
}